import { createFileRoute, redirect } from '@tanstack/react-router';

import { Discounts } from '~pages/settings/discounts';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { UserRoles } from '~entities/users';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/discounts')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: RouteComponent,
});

function RouteComponent() {
  return <Discounts />;
}
